module.exports = "/_next/static/images/GeneralXL-603612eac308a878e06321758a5e3ef9.svg";